import { Box, Text, Heading } from '@primer/react';
import Reveal from './Reveal';

const areas = [
  {
    title: 'SaaS UX Design',
    description:
      'The SaaS UX design partner ambitious product teams call when growth stalls and the UI can’t keep up. From SaaS UI/UX design to full product overhauls, we build interfaces users actually want to use.',
  },
  {
    title: 'FinTech UX Design',
    description:
      'Fintech UX design for teams building trust one interaction at a time. We’ve shipped fintech UI/UX for platforms handling real money, real risk, and real compliance requirements.',
  },
  {
    title: 'Enterprise UX Consulting',
    description:
      'UX for enterprise applications is a different discipline entirely: legacy systems, dozens of stakeholders, workflows nobody dares touch. We specialize in enterprise UX consulting that ships anyway.',
  },
  {
    title: 'AI UX Design',
    description:
      'AI UX design for products where trust, transparency, and control make or break adoption. We partnered with GitHub to help design the interface layer for Copilot AI.',
  },
  {
    title: 'Logistics UX Design',
    description:
      'Logistics UX design for the dashboards, tracking tools, and operations software that keep freight moving. Complex data, made usable.',
  },
  {
    title: 'Web App UX Design',
    description:
      'Web app UX design for products where every extra click costs you a user. We design web applications that are as fast to use as they are powerful.',
  },
  {
    title: 'UX Audits & UX Testing',
    description:
      'A UX audit company and UX testing services built for speed. Get a heuristic evaluation, accessibility audit, and prioritized findings report without committing to a full engagement.',
  },
  {
    title: 'UI/UX Design Consulting',
    description:
      'As UI design consultants and a UX consulting company, we plug directly into your existing product org, no lengthy onboarding, no junior hand-offs.',
  },
];

function Expertise() {
  return (
    <Box sx={{ backgroundColor: 'canvas.default', paddingX: ['24px', '48px', '100px'], paddingY: [7, 8, 9] }}>
      <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
        <Reveal>
          <Text
            as="p"
            sx={{
              margin: 0,
              marginBottom: 2,
              fontSize: 1,
              fontWeight: 600,
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              color: 'fg.muted',
            }}
          >
            What We're Known For
          </Text>
          <Heading
            as="h2"
            sx={{
              margin: 0,
              marginBottom: [6, 7, 8],
              maxWidth: '760px',
              fontFamily: "'Fraunces', serif",
              fontWeight: 300,
              fontSize: ['2rem', '2.75rem', '3.25rem'],
              lineHeight: 1.25,
              color: 'fg.default',
            }}
          >
            The UI/UX design company for SaaS, fintech, enterprise & AI teams.
          </Heading>
        </Reveal>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(2, 1fr)', 'repeat(4, 1fr)'],
            gap: [5, 5, 5],
          }}
        >
          {areas.map((area, index) => (
            <Reveal key={area.title} delay={index * 0.05}>
              <Box
                sx={{
                  height: '100%',
                  borderRadius: '16px',
                  border: '1px solid',
                  borderColor: 'border.default',
                  padding: 4,
                }}
              >
                <Heading as="h3" sx={{ margin: 0, marginBottom: 2, fontSize: 2, fontWeight: 600, color: 'fg.default' }}>
                  {area.title}
                </Heading>
                <Text as="p" sx={{ margin: 0, fontSize: 1, lineHeight: 1.7, color: 'fg.muted' }}>
                  {area.description}
                </Text>
              </Box>
            </Reveal>
          ))}
        </Box>
      </Box>
    </Box>
  );
}

export default Expertise;
